import { useState, type ReactNode } from 'react';
import { useT } from '../lib/i18n';

/**
 * Confirmation dialog. With `phrase`, the confirm button stays disabled until the exact
 * phrase is typed — the second of the double confirmation for GO-LIVE / PANIC.
 */
export function ConfirmDialog(props: {
  title: string;
  children: ReactNode;
  confirmLabel: string;
  danger?: boolean;
  phrase?: string;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}): JSX.Element {
  const [typed, setTyped] = useState('');
  const t = useT();
  const ready = props.phrase === undefined || typed === props.phrase;
  return (
    <div className="overlay" role="dialog" aria-modal="true" aria-label={props.title}>
      <div className="dialog stack">
        <h3>{props.title}</h3>
        <div className="muted">{props.children}</div>
        {props.phrase !== undefined && (
          <label className="field">
            {t('Type the phrase to confirm:')} <code>{props.phrase}</code>
            <input autoFocus value={typed} onChange={(e) => { setTyped(e.target.value); }} autoComplete="off" />
          </label>
        )}
        <div className="row" style={{ justifyContent: 'flex-end' }}>
          <button onClick={props.onCancel} disabled={props.busy}>{t('Cancel')}</button>
          <button className={props.danger ? 'danger' : 'primary'} disabled={!ready || props.busy} onClick={props.onConfirm}>
            {props.busy ? t('Working…') : props.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
